module.exports = __webpack_public_path__ + "static/media/Open-eye.b0568b4e.svg";